export class PublishRequest
{
    constructor(
            public readonly projectId:number, 
            public readonly designId:number, 
            public readonly settingsId:number, 
            public readonly cname:string, 
            public readonly urlPart:string, 
            public readonly sharingMode:any, 
            public readonly beta:boolean
        )
    {}
}
